import { PasswordSearchCriteria } from "./PasswordSearchCriteria";

export class PasswordState {
    passwordSearchCriteria: PasswordSearchCriteria = new PasswordSearchCriteria();
    archiveSearchCriteria: PasswordSearchCriteria = new PasswordSearchCriteria();
}